// Local Deps
import { makeGraphQLRequest } from '../utils/requestUtils';

// export async function createUser({
//   name = null,
//   email = null,
//   role = null,
//   organizationId = null,
//   phoneNumber = null,
//   auth0Id = null,
//   id = null,
// }) {

//   // Format Mutation
//   const query = `mutation createUser(
//     $user: NewUserInput
//   ) {
//      createUser(user:$user)
//       {
//         name,
//         email,
//         role,
//         organizationId,
//         phoneNumber,
//       }
//     }`;

//   // Variables
//   const variables = {
//     user: { id, name, email, role, organizationId, phoneNumber, auth0Id },
//   };

//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });
//   return response;
// }

export async function requestPassword(id) {
  const query = `mutation requestPasswordReset(
    $id: ID
  ){
    requestPasswordReset(id: $id){
        id
      
    }
  }`;
  const variables = {
    id,
  };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function requestUserById(id) {
  // Format Query
  const query = `query organization(
    $id: ID
  ) {
    organization(id: $id) {
       
        matchSettingList {
          materials
          methods
          minimumQuantity
          minimumEstimatedCost
        }
      }
    }`;

  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  if (response.organization.matchSettingList) {
    response.organization.matchSettingList.methods = response.organization.matchSettingList.methods.filter(
      () => true // && method !== 'machining/other',
    );
  }

  return response;
}

export async function UserForApproveUser(id) {
  // Format Query
  const query = `query requestUserById(
        $id: ID
      ) {
          user(id: $id) {
            name
            phoneNumber  	
            email  	
            id  	
            organizationId 
            iconStatus
            role
            permissions
            auth0Id
            cageCode
          }
        }`;

  // Variables
  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function requestUserByEmail(email) {
  const query = `query userByEmail(
        $email: String
  ) {
      userByEmail(email: $email) {
        name
        phone  	
        email  	
        id  	
        organizationId 
        iconStatus
        role
        auth0Id
      }
    }`;

  const variables = { email };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}
export async function userEmailExists(email) {
  const query = `query userByEmailStatus(
        $email: String
  ) {
      userByEmailStatus(email: $email) {
        iconStatus
      }
    }`;

  const variables = { email };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getGovernmentUsers(type = 'government') {
  const query = `query governmentUsers($type: String!) {
    governmentUsers(type: $type) {
      govProcUserData {
        name
        phone  	
        email  	
        id  	
        organizationId 
        iconStatus
        role
        cageCode
        orgName
        auth0Id
        orgStatus
      }
    }
  }`;
  const variables = { type };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function allProcurementUser(type = 'all') {
  const query = `query allProcurementUser($type: String!) {
    allProcurementUser(type: $type) {
      govProcUserData {
        name
        phone  	
        email  	
        id  	
        organizationId 
        iconStatus
        role
        cageCode
        orgName
        auth0Id
        orgStatus
      }
    }
  }`;
  const variables = { type };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function deleteUser(id) {
  const query = `mutation deleteUser( $id: ID) { deleteUser (id: $id) { id } }`;

  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export default {
  UserForApproveUser,
  requestUserById,
  requestUserByEmail,
  deleteUser,
};



// WEBPACK FOOTER //
// ./src/graphql/users.js